import { put } from "redux-saga/effects";
import { checkSession, Update_username } from "../../Services";

export function* CheckSessionSaga(action) {
  const payload = action.payload;
  try {
    const res = yield checkSession(payload);

    yield put({ type: "REQ_SESSION_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_SESSIONE_FAILED", errData: e });
  }
}
